export default {
  getShowTaskDetails: (state) => state.showTaskDetails,
  getTaskId: (state) => state.taskId,
};
